import React from "react";
import T from "i18n-react";
import Styles from "../styles.module.scss";
import { useSelector } from "react-redux";
import { SelectedOrderType } from "../types.d";
import useCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import { CARDIFF_CASTLE } from "../../../constants";
import { addTaxes } from "../../../yoello-lib/modules/utils/TaxController";

interface IPricingComponentProps {
  tip: number;
  transactionFee: number;
  itemCost: number;
  totalCost: number;
  deliveryCharge: number;
  cartItemTaxAmount: number | null;
  serviceTaxAmount: number | null;
  cartItemInclusiveTaxAmount: number | null;
  sericeTaxInclusiveTaxAmount: number | null;
  deliveryTaxAmount: number | null;
  deliveryInclusiveTaxAmount: number | null;
}

function PricingComponent({
  tip,
  transactionFee,
  itemCost,
  totalCost,
  deliveryCharge,
  cartItemTaxAmount,
  serviceTaxAmount,
  cartItemInclusiveTaxAmount,
  sericeTaxInclusiveTaxAmount,
  deliveryTaxAmount,
  deliveryInclusiveTaxAmount,
}: IPricingComponentProps) {
  const { formatCurrency } = useCurrency();
  const Group = useSelector((state: any) => state.Group);
  const SelectedMenuType = useSelector((state: any) => state.SelectedMenuType);
  const totalTax = addTaxes(
    cartItemTaxAmount,
    serviceTaxAmount,
    deliveryTaxAmount
  );
  const inclusiveTax = addTaxes(
    cartItemInclusiveTaxAmount,
    sericeTaxInclusiveTaxAmount,
    deliveryInclusiveTaxAmount
  );

  const total = totalCost + totalTax;
  const formattedItemCost = formatCurrency(itemCost);
  const formattedTip = formatCurrency(tip);
  const formattedTotalCost = formatCurrency(total);
  const formattedDelivery = formatCurrency(deliveryCharge);
  const formattedTransactionFee = formatCurrency(transactionFee);
  const formattedTaxTotal = formatCurrency(totalTax + inclusiveTax);
  return (
    <div className={Styles.BillSummaryDiv}>
      <div className={Styles.BillSummarySectionDivs}>
        <T.p text={{ key: `Payment.ItemsPrice` }} />
        <p className="Price">{formattedItemCost}</p>
      </div>
      <div className={Styles.BillSummarySectionDivs}>
        <T.p text={{ key: `Payment.TipPrice` }} />
        <p className="Price">{formattedTip}</p>
      </div>
      {(Group?.group_service_charge_enabled &&
        Group?.group_nickname === CARDIFF_CASTLE) ||
      SelectedMenuType === SelectedOrderType.DELIVERY ? (
        <div className={Styles.BillSummarySectionDivs}>
          <T.p text={{ key: `Payment.DeliveryPrice` }} />

          <p>{formattedDelivery}</p>
        </div>
      ) : null}
      {transactionFee ? (
        <div className={Styles.BillSummarySectionDivs}>
          <T.p text={{ key: `Payment.ServiceCharge` }} />

          <p>{formattedTransactionFee}</p>
        </div>
      ) : null}
      {formattedTaxTotal ? (
        <div className={Styles.BillSummarySectionDivs}>
          <T.p text={{ key: `Payment.Taxes` }} />

          <p>{formattedTaxTotal}</p>
        </div>
      ) : null}
      <div className={Styles.TotalPriceDiv}>
        <T.p text={{ key: `Payment.TotalPay` }} />
        <p>{formattedTotalCost}</p>
      </div>
    </div>
  );
}

export default PricingComponent;
